import React from "react";

const Features = () => {
  return (
    <section class="section feature" aria-labelledby="feature-label">
      <div class="container">
        <figure class="feature-banner">
          <img
            src="./assets/images/feature-banner.png"
            width="800"
            height="531"
            loading="lazy"
            alt="feature banner"
            class="w-100"
          />
        </figure>

        <div class="feature-content">
          <p class="section-subtitle" id="feature-label">
            Our Services
          </p>

          <h2 class="h2 section-title">
            We make your travel experience smooth and enjoyable with top-quality
            taxi services.
          </h2>

          <p class="section-text">
            We understand your travel needs and are committed to providing you
            with a comfortable, safe, and hassle-free ride to any destination.
          </p>

          <ul class="feature-list">
            <li>
              <div class="feature-card">
                <div class="card-icon">
                  <ion-icon name="checkmark" aria-hidden="true"></ion-icon>
                </div>

                <span class="span">
                  Reliable and punctual service for all your transportation
                  needs.
                </span>
              </div>
            </li>

            <li>
              <div class="feature-card">
                <div class="card-icon">
                  <ion-icon name="checkmark" aria-hidden="true"></ion-icon>
                </div>

                <span class="span">
                  Clean, well-maintained vehicles to ensure your comfort and
                  safety.
                </span>
              </div>
            </li>

            <li>
              <div class="feature-card">
                <div class="card-icon">
                  <ion-icon name="checkmark" aria-hidden="true"></ion-icon>
                </div>

                <span class="span">
                  Friendly and experienced drivers who know the best routes.
                </span>
              </div>
            </li>

            <li>
              <div class="feature-card">
                <div class="card-icon">
                  <ion-icon name="checkmark" aria-hidden="true"></ion-icon>
                </div>

                <span class="span">
                  Affordable pricing with no hidden charges or surprises.
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Features;
